function VehicleRegistrationRegion(data) {
    var result = 'MOT';
	const vehicleClasses = ["HGV", "HCV", "LCV","VAN"];
	/*if(data.registration_region == 'UK'){
		if(vehicleClasses.includes(data.class)){
			result = 'PSV';
		}
	}else*/
	if(data.registration_region == 'IRL'){
		result = 'NCT';
		if(vehicleClasses.includes(data.class)){
			result = 'CVRT';
		}
	}
    return result;
}
  export default VehicleRegistrationRegion;
